import React, {useState, useEffect, useContext} from "react";
import {functions} from "../../constants/common-functions";
import {childDashboardsUtilisation} from "../../constants/dashboards-children";
import AmChartDateLine from "../../components/AmChartDateLine";
import AmChartDateStackedEmptyTop from "../../components/AmChartDateStackedEmptyTop";
import AmChartStacked from "../../components/AmChartStacked";
import DashboardToolPanel from "../../components/DashboardToolPanel";
import ChartCardLarge from "../../components/ChartCardLarge";
import UtilityDashboardLayout from "../../components/dashboardlayouts/UtilityDashboardLayout";
import {utilityDashboardComponentContainer} from "../../constants/styles";
import {store} from '../../context/store';

export default function UtilisationTimeline(){
	
	
	const [data1, setData1] = useState([]);
	const [data2, setData2] = useState([]);
	const [data3, setData3] = useState([]);
	const [data4, setData4] = useState([]);
	const [data5, setData5] = useState([]);
	const [graphs5, setGraphs5] = useState([]);
	const [dataIndex, setDataIndex] = useState(0);
	const [displayOccupancyVacancy, setDisplayOccupancyVacancy] = useState("flex");
	const [displayOccupancyVacancy100, setDisplayOccupancyVacancy100] = useState("none");
	const [displayUtilisation, setDisplayUtilisation] = useState("none");
	const [displayUtilisationEfficiency, setDisplayUtilisationEfficiency] = useState("none");
	const [displayOccupancyCapacity, setDisplayOccupancyCapacity] = useState("none");
	const [displayActivity, setDisplayActivity] = useState("none");
	const [loaded, setLoaded] = useState(false);
	
	const globalState = useContext(store);
		
	const utilisationSurveyId =
	    globalState?.state?.queryContext?.utilisationSurveyId ?? null;

	
	useEffect(() => {
		
		if(loaded === false){
			loadData(dataIndex);
			setLoaded(true);
		}
	
		
		
	}, [dataIndex, utilisationSurveyId]);
	
	const loadData = (dataIndex) => {
		switch(dataIndex) {
		  case 0:
		    loadData1();
		    break;
		  case 1:
		    loadData2();
		    break;
		  case 2:
		    loadData3();
		    break;
		  case 3:
		    loadData4();
		    break;
		   case 4:
		    loadData5();
		    break;
		  default:
		    loadData1();
		}
	};

	
	const loadData1 = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetbydatewithfilterandsignsoflife?utilisationSurveyId=" + utilisationSurveyId, setData1, handleData1);
	};
	
	
	const handleData1 = (results) => {
	   const tempData = results.map(({label, vacant, occupied, signsOfLife }) => ({
	    	id: label,              
	      date:functions.convertUtilisationLabelToDate(label),                  
	      vacant: parseInt(vacant),
	      occupied: parseInt(occupied),
	      signsOfLife: parseInt(signsOfLife)
	  }));
	  setData1(tempData);
	};
	
	const loadData2 = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetbydatewithfilter?utilisationSurveyId=" + utilisationSurveyId, setData2, handleData2);
	};
	
	
	const handleData2 = (results) => {
	  const tempData = results.map(({label, avg }) => ({
	    id:label,
	    date:functions.convertUtilisationLabelToDate(label),
	    utilisation: parseInt(avg),
	  }));
	  setData2(tempData);
	};
	
	const loadData3 = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetutilisationefficiencyovertime?utilisationSurveyId=" + utilisationSurveyId, setData3, handleData3);
	};
	
	
	const handleData3 = (results) => {
	  const tempData = results.map(({groupBy, value1, value2}) => ({
	    id:groupBy,
	    date:functions.convertUtilisationLabelToDate(groupBy),
	    efficiency: parseInt(value1),
	    utilisation: parseInt(value2),
	  }));
	  
	  setData3(tempData);
	};
	
	const loadData4 = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetcapacityoccupancyovertime?utilisationSurveyId=" + utilisationSurveyId, setData4, handleData4);
	};
	
	const handleData4 = (results) => {
	  const tempData = results.map(({groupBy, value1, value2}) => ({
	    id:groupBy,
	    date:functions.convertUtilisationLabelToDate(groupBy),
	    remainingCapacity: parseInt(value1),
	    occupancy: parseInt(value2),
	  }));
	  
	  setData4(tempData);
	};
	
	const loadData5 = () => {
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetactivityovertime?utilisationSurveyId=" + utilisationSurveyId, setData5, handleData5);
	};
	
	const handleData5 = (obj) => {
		setGraphs5(obj.graphs);
		setData5(obj.returnObjects);
	};
	 	
	 	const chartHeader = {
			display:"flex",
	 		width:"100%",
	 		height:"2S0px",
	 		fontWeight:"bold",
	 		fontSize:"12px",
	 		marginTop:"10px",
			justifyContent:"space-around"
	 	};
	
	const refreshFunction = () => {
		loadData(dataIndex);
	};
	
	const dataByDateGraphsUtilisation = [
 		{id:"utilisation", title:"Average Utilisation", keyColumn:"utilisation", color:"blue"}
 	];
 	
 	const dataByDateGraphsStacked = [
 		{id:"occupied", title:"Occupied", keyColumn:"occupied", color:"#E92864"},
 		{id:"signsOfLife", title:"Signs Of Life", keyColumn:"signsOfLife", color:"#0327BC"},
 		{id:"vacant", title:"Available", keyColumn:"vacant", color:"#38A500"}
 	];
 	
 	const dataByDateGraphsUtilisationEfficiency = [
 		{id:"utilisation", title:"Utilisation", keyColumn:"utilisation", color:"green"},
 		{id:"efficiency", title:"Efficiency", keyColumn:"efficiency", color:"blue"}
 	];
 	
 	const chartKeysOccupancyCapacity = [
 		{id:"occupancy", name:"occupancy", color:"#0099ff"},
 		{id:"remainingCapacity", name:"remainingCapacity", color:"#0099ff"}
 	];
 	
 	
 	const resetDisplay = (index) => {
 		setDataIndex(index);
 		loadData(index);
 		setDisplayOccupancyVacancy("none");
 		setDisplayOccupancyVacancy100("none");
 		setDisplayUtilisation("none");
 		setDisplayUtilisationEfficiency("none");
 		setDisplayOccupancyCapacity("none");
 		setDisplayActivity("none");
 	};
 	
 	const showOccupancyVacancy = () => {
 		resetDisplay(0);
 		setDisplayOccupancyVacancy("flex");
 	};
 	
 	const showOccupancyVacancy100 = () => {
 		resetDisplay(0);
 		setDisplayOccupancyVacancy100("flex");
 	};
 	
 	const showUtilisation = () => {
 		resetDisplay(1);
 		setDisplayUtilisation("flex");
 	};
 	
 	const showUtilisationEfficiency = () => {
 		resetDisplay(2);
 		setDisplayUtilisationEfficiency("flex");
 	};
 	
 	const showOccupancyCapacity = () => {
 		resetDisplay(3);
 		setDisplayOccupancyCapacity("flex");
 	};
 	
 	const showActivity = () => {
 		resetDisplay(4);
 		setDisplayActivity("flex");
 	};
 	
 	const toolActions =[
		{label:'Occupancy & Vacancy', actionFunction:showOccupancyVacancy},
		{label:'Stack 100%', actionFunction:showOccupancyVacancy100},
		{label:'Utilisation %', actionFunction:showUtilisation},
		{label:'Utilisation & Effficiency', actionFunction:showUtilisationEfficiency},
		{label:'Occupancy vs Capacity', actionFunction:showOccupancyCapacity},
		{label:'Activity', actionFunction:showActivity}
	];
 	
	return (
		<UtilityDashboardLayout
			    title="Utilisation Timelines"
			    childDashboards={childDashboardsUtilisation}
			    refreshFunction={refreshFunction}
			  >
			  <div style={{...utilityDashboardComponentContainer, display:displayOccupancyVacancy}}>
				<ChartCardLarge title="Occupied/Vacant">
					<AmChartDateLine
						chartId="utilisationtimestackchart"
						width="100%"
						height="calc(100% - 30px)"
						chartData={data1}
						graphs={dataByDateGraphsStacked}
						dateKey="date"
						isStacked="true"
					/>
				  </ChartCardLarge>
					
				</div>
				<div style={{...utilityDashboardComponentContainer, display:displayOccupancyVacancy100}}>
					<ChartCardLarge title="Occupied/Vacant (Stack 100%)">
						<AmChartDateLine
							chartId="utilisationtimestackchart100"
							width="100%"
							height="calc(100% - 30px)"
							chartData={data1}
							graphs={dataByDateGraphsStacked}
							dateKey="date"
							isStacked="true"
							isStack100="true"
						/>
					  </ChartCardLarge>
				</div>
				<div style={{...utilityDashboardComponentContainer, display:displayUtilisation}}>
					<ChartCardLarge title="Utilisation %">
						<AmChartDateLine
							chartId="utilisationtimeutilisation"
							width="100%"
							height="calc(100% - 30px)"
							chartData={data2}
							graphs={dataByDateGraphsUtilisation}
							dateKey="date"
						/>
					 </ChartCardLarge>
				</div>
				<div style={{...utilityDashboardComponentContainer, display:displayUtilisationEfficiency}}>
					<ChartCardLarge title="Utilisation & Efficiency">
						<AmChartDateLine
							chartId="utilisationtimeutilisationefficiency"
							width="100%"
							height="calc(100% - 30px)"
							chartData={data3}
							graphs={dataByDateGraphsUtilisationEfficiency}
							dateKey="date"
						/>
					  </ChartCardLarge>
				</div>
				<div style={{...utilityDashboardComponentContainer, display:displayOccupancyCapacity}}>
					<ChartCardLarge title="Occupancy vs Capacity">
						<AmChartDateStackedEmptyTop
							chartId="utilisationtimeoccupancycapacity"
							width="100%"
							height="calc(100% - 30px)"
							chartData={data4}
							chartKeys={chartKeysOccupancyCapacity}
							dateKey="date"
						/>
					  </ChartCardLarge>
				</div>
				<div style={{...utilityDashboardComponentContainer, display:displayActivity}}>
					<ChartCardLarge title="Activity">
						<AmChartStacked
							chartId="utilisationtimeactivity"
							width="100%"
							height="calc(100% - 30px)"
							chartData={data5}
							chartKeys={graphs5}
							categoryKey="title"
						/>
					  </ChartCardLarge>
				</div>
				<DashboardToolPanel
					title="Choose Chart"
					actions={toolActions}
				/>	
		</UtilityDashboardLayout>
			
	);
}